import React from 'react';
import { Sheet, Typography, Box, Divider } from '@mui/joy';
import DashboardWidgets from '../components/dashboard/DashboardWidgets';
import NavigationBranches from '../components/dashboard/NavigationBranches';
import PermissionWrapper from '../components/PermissionWrapper';

const DashboardPage = () => {
    return (
        <Sheet sx={{ p: 4, maxWidth: '1400px', mx: 'auto' }}>
            {/* Welcome Header */}
            <Box sx={{ mb: 4 }}>
                <Typography level="h2" sx={{ mb: 1 }}>
                    Dashboard
                </Typography>
                <Typography level="body-lg" textColor="neutral.600">
                    Welcome to the AiHub Administration Panel
                </Typography>
            </Box>

            {/* System Overview Widgets - visible to users with dashboard permissions */}
            <PermissionWrapper 
                requiredPermissions={['dashboard:read', 'dashboard:write']}
                fallback={null}
            >
                <DashboardWidgets />
                <Divider sx={{ my: 4 }} />
            </PermissionWrapper>

            {/* Navigation Branches - each branch has its own permission check */}
            <NavigationBranches />
        </Sheet>
    );
};

export default DashboardPage; 